import { styled } from '@fareye/ui'

export const GraphGrid = styled.div`
  display: grid;
  background: #f0f2f5;
  padding: 1em;
  grid-template-columns: 50% 50%;
  grid-gap: 1em;
  height: auto;
  @media only screen and (max-width: 425px) {
    grid-template-columns: 1fr;
  }
`
export const HorizontalScrollGrid = styled.div`
  display: flex;
  grid-gap: calc(20px / 2);
  /* grid-template-columns: 10px; */
  grid-template-rows: minmax(70px, 1fr);
  grid-auto-flow: column;
  grid-auto-columns: calc(27% - 20px * 2);
  overflow-x: scroll;
  scroll-snap-type: x proximity;
  padding: 1vw;
  background-color: #f0f2f5;
  scrollbar-width: none;
  margin-bottom: 0;
  padding-bottom: 0;
  &::-webkit-scrollbar {
    display: none;
  }
`
